<template>
    <div class="container">
        <div class="main-block">
            <div class="store-block" v-if="isLogin">

                <Gift isWeb :isTypeWeb="'coupon'"/>

            </div>
        </div>

        <!--判斷有無登入-->
        <LoginWeb/>
    </div>
</template>

<script>
    import * as mutationTypes from '@/store/mutationTypes';
    import Gift from "@/views/gift/Index";
    import LoginWeb from "./components/LoginWeb";

    export default {
        name: "WebStoreCoupon",
        components: {
            Gift,
            LoginWeb,
        },
        data() {
            return {
                isLogin: this.$auth.isAdminLogin(),
            }
        },
        created() {


        },
        mounted() {


        },
        methods: {

            /** setup */
            setupData: function () {

                // 不載入資料，讓 Gift元件自己抓資料
                // Gift底下的 UseItem元件自行呼叫 api，所以從 vuex 傳值(filterStoreId)給 UseItem等組件使用

            },


        },
    }
</script>
